module.exports = __webpack_public_path__ + "img/Ignacio_Anaya.8f091e25.jpg";